<template>
  <div>
    <autocomplete
      v-model="model"
      :loading="loading"
      :items="computedItems"
      item-text="code"
      return-object
      :label="placeholder ? '' : label || $t('code') + $t('of_article')"
      :placeholder="placeholder"
      :hide-details="hideDetails"
      :rules="rules"
      :color="color"
      :hint="hint"
      :persistent-hint="persistentHint"
      show-item-slot
      :required="required"
      show-selection-slot
      :filter="customFilter"
      prepend-item
      @enter="itemSelected"
      @update:search-input="search = $event"
    >
      <template v-slot:prepend-item v-if="!disableAdd">
        <v-list-item @click="openAddDialog">
          <v-list-item-title>
            <v-icon color="primary">mdi-plus-circle</v-icon>
            <strong class="ml-2">{{ $t("add_grocery") }}</strong>
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
      </template>
      <template v-slot:item="{ item }">
        <div>
          <small>{{ item.code }}</small> -
          <span class="grey--text">{{ toLatin(item.name) }}</span>
        </div>
      </template>
      <template v-slot:selection="{ data }">
        <div>
          <small>{{ data.item.code }}</small> -
          <span class="grey--text">{{ toLatin(data.item.name) }}</span>
        </div>
      </template>
    </autocomplete>

    <grocery-dialog
      v-model="groceryDialog"
      :edited-item="newGrocery"
      @groceryCreated="handleGroceryCreated"
      @groceryUpdated="handleGroceryUpdated"
    />
  </div>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import GroceryDialog from "@/components/groceries/dialogs/GroceryDialog.vue";
import { defaultGrocery } from "@/models/food";

export default {
  mixins: [hasModel],
  components: {
    GroceryDialog,
  },
  props: {
    groceries: {
      type: Array,
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    color: {
      type: String,
      default: "default",
    },
    disableAdd: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    hint: {
      type: String,
      default: "",
    },
    persistentHint: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: false,
    search: null,
    groceryDialog: false,
    newGrocery: {},
  }),
  computed: {
    computedItems() {
      return this.groceries.filter((item) => item?.code);
    },
  },
  methods: {
    customFilter(item, queryText) {
      // Filter items by code or name
      const searchLower = (queryText || "").toLowerCase();
      const code = (item.code || "").toLowerCase();
      const name = (item.name || "").toLowerCase();

      return code.includes(searchLower) || name.includes(searchLower);
    },
    itemSelected(grocery) {
      this.$emit("enter", grocery);
    },
    openAddDialog() {
      this.newGrocery = { ...defaultGrocery, name: this.search || "" };
      this.groceryDialog = true;
    },
    handleGroceryCreated(grocery) {
      this.model = grocery;
      setTimeout(() => {
        this.$emit("groceryCreated", grocery);
        this.$emit("enter", grocery);
        this.groceryDialog = false;
      }, 100);
      // Auto-select the newly created item
    },
    handleGroceryUpdated(grocery) {
      this.$emit("groceryUpdated", grocery);
      this.groceryDialog = false;
    },
  },
};
</script>
